import React, { Component } from "react";
import { Link, withRouter } from "react-router-dom";
import api from "../../services/api";

import CourseFeaturesIndex from "./coursesfeature"



import Card1 from "../../assets/img/banners/card1.png"
import Card2 from "../../assets/img/banners/card2.png"
import Card3 from "../../assets/img/banners/card3.png"


import Cardenfermangem from "../../assets/img/banners/box_courses/enfermagem.jpg"
import CardenfADM from "../../assets/img/banners/box_courses/adm.jpg"
import CARDGD from "../../assets/img/banners/box_courses/gestaoedesenvolvimento.jpg"

class FeaturesIndex extends Component {

  constructor() {
    super();

    this.state = { 
      categorias: [],
      configuracao:[]
    }
      
  }



  async componentDidMount() {

    const response1 = await api.get("/categorias", {idunidade:localStorage.getItem('idunidade')});
    this.setState({ 
      categorias: response1.data})

      

      const response = await api.post("/configuracao/show");
      this.setState({ configuracao: response.data
       });



    }



  render() {
    return (
      <React.Fragment>
     <div class="container featureindex">
     <div class="row">
          <div class="col-lg-4 featurescards">
            <img class="featurescardsimg" src={Card1} alt="Generic placeholder image" width="120" height="190"/>
            <h4>Tradição & Qualidade</h4>
            <p>{this.state.configuracao.cardtext1}</p>
            <p><a class="btn btn-info" href="/pos-graduacao">Ver mais</a>
            </p>
          </div>
          <div class="col-lg-4 featurescards">
            <a href={"https://bityli.com/33dfw"} target="_blank">
              <img class="featurescardsimg" src={Card2} alt="Generic placeholder image" width="120" height="190"/>
            </a>
            <h4>Localização & InfraEstrutura</h4>
            <p>{this.state.configuracao.cardtext2}</p>
            <p><a class="btn btn-info" href="/pos-graduacao">Ver mais</a>
            </p>
          </div>
          <div class="col-lg-4 featurescards">
            <img class="featurescardsimg" src={Card3} alt="Generic placeholder image" width="120" height="190" /> 
            <h4>Mensalidades Justas</h4>
            <p>{this.state.configuracao.cardtext3} </p>
            <p><a class="btn btn-info" href="/pos-graduacao">Ver mais</a>
            </p>
          </div>
        </div>
        










      <div class="catologo-curso">

        <div class="d-flex justify-content-center courseindex-title">
          <h2>Nossos Cursos de Pós-Graduação
          </h2>
          </div>

          {this.state.categorias.map(el => (
            
            <div>
            <h3 class="d-flex justify-content-center ">{el.nome}</h3>

            <div class="container col-sm imgcurso">
              
              <CourseFeaturesIndex idcategoria={el.id} />
             
            </div>
               
            </div>
            ))}


          
                
                
                
            


          









          
          </div>





      


















<br></br><br></br><br></br><br></br><br></br>
</div>

        
      </React.Fragment>
       
    );
  }
}

export default withRouter(FeaturesIndex);


// WEBPACK FOOTER //
// ./src/pages/content/featureindex.js